import { render, staticRenderFns } from "./LoginHistoryTable.vue?vue&type=template&id=00063416&scoped=true"
import script from "./LoginHistoryTable.vue?vue&type=script&lang=js"
export * from "./LoginHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00063416",
  null
  
)

export default component.exports